import { ISendReport, ISendReportAction } from './sendReport.interface';
import { SendReportTypes } from './sendReport.type';

export const sendReport = (payload: ISendReport): ISendReportAction => ({
	type: SendReportTypes.SEND_REPORT,
	payload,
});
